import { useCallback, useMemo } from 'react';

import { NavigatorScreenParams, useNavigation } from '@react-navigation/native';
import { NativeStackNavigationProp } from '@react-navigation/native-stack';

import { useActiveWallet } from '@/hooks/use-active-wallet';
import { useSocialWalletTranslation } from '@/hooks/use-social-wallet-translation';
import { DepositStackParamList, RootStackParamList } from '@/navigation/types';

/**
 * Shared "no valid payment method on file" messaging and the wallet-aware deposit
 * destination, so the post-IDPV success modal and the wallet Withdraw button point
 * method-less users to the same place with the same words.
 */
export const useNoPaymentMethodDeposit = () => {
    const navigation = useNavigation<NativeStackNavigationProp<RootStackParamList>>();
    const tSocialWalletAccount = useSocialWalletTranslation('account');
    const tSocialWalletKyc = useSocialWalletTranslation('kyc');
    const { isSharedSocialWallet } = useActiveWallet();

    // Resolved at render so callers can list stable strings, not the per-render
    // translator functions, in their dependency arrays.
    const description = tSocialWalletAccount('withdraw_verification_no_payment_method_description');
    const depositLabel = tSocialWalletKyc('make_deposit');

    const depositRoute: NavigatorScreenParams<DepositStackParamList> = useMemo(
        () => (isSharedSocialWallet ? { screen: 'CoinPackageScreen' } : { screen: 'DepositScreen', params: {} }),
        [isSharedSocialWallet]
    );

    const navigateToDeposit = useCallback(
        () => navigation.navigate('DepositStack', depositRoute),
        [depositRoute, navigation]
    );

    return { description, depositLabel, depositRoute, navigateToDeposit };
};
